/* common imports */
import React from "react";

/* component imports */

/* @mui imports */

import { Link, List, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useRouter } from "next/router";

type CustomAttributesForDivElement = {
	index?: number;
};

/* stylings */

const SectionContainer = styled("div")<CustomAttributesForDivElement>(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	width: "100%",
	[theme.breakpoints.down("xsPlus")]: {
		display: "flex",
		flexDirection: "column",
		// padding: "3rem 1.2rem 3rem 1.2rem",
		// margin: "1.75rem 0rem 1rem 0rem",
	},
}));

const Heading = styled(Typography)(({ theme }) => ({
	display: "flex",
	color: theme.palette.primary.main,
	justifyContent: "flex-start",
	alignItems: "flex-start",
	fontWeight: 400,
	fontSize: "2rem",
	lineHeight: "3.1875rem",
	padding: "1rem 0rem 1rem 0rem",
	[theme.breakpoints.down("sm")]: {
		fontSize: "1.5rem",
		lineHeight: "2.25rem",
	},
}));

const SubHeading = styled(Typography)(({ theme }) => ({
	display: "flex",
	textAlign: "justify",
	padding: "1rem 0rem 1rem 0rem",
	width: "100%",
	color: theme.palette.mode == "dark" ? "#FFFFFF" : "#000000",
	fontWeight: "250",
	fontSize: "1.125rem",
	lineHeight: "1.75rem",
	[theme.breakpoints.down("xsPlus")]: {
		fontSize: "1.125rem",
		lineHeight: "1.6875rem",
	},
}));

const SectionTwo = () => {
	const router = useRouter();
	const localLang = {
		definitions:
			router.locale === "ar-AE"
				? "١. التعريفات"
				: router.locale === "kn-IN"
					? "1. ಗೌಪ್ಯತಾ ನೀತಿ ಹೇಳಿಕೆ"
					: "1. Definitions",
		definitionsContentOne:
			router.locale === "ar-AE"
				? `١.١. "المعلومات الشخصية" تعني المعلومات التي تُعرّفك (تُعرّف فردًا) والتي يتم جمعها من قِبَل الشركة من خلال استخدامك للمنصة الإلكترونية أو التي تقدمها بصيغة رقمية.`
				: router.locale === "kn-IN"
					? "1.1. “ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ” ಎಂದರೆ ನಿಮ್ಮನ್ನು ಗುರುತಿಸುವ ಮಾಹಿತಿ (ವ್ಯಕ್ತಿಯನ್ನು ಗುರುತಿಸುವ ಮಾಹಿತಿ) ಮತ್ತು ಕಂಪನಿಯ ಮೂಲಕ ನಿಮ್ಮ ಬಳಕೆಯ ಮೂಲಕ ನಿಮ್ಮಿಂದ ಸಂಗ್ರಹಿಸಲಾಗಿದೆ ಅಥವಾ ಡಿಜಿಟಲ್ ರೂಪದಲ್ಲಿ ನೀಡಲಾಗಿದೆ."
					: "1.1. “Personal Information” shall mean information that identifies you (identifies an individual) and is collected by the company through your use of the online platform or provided by you in digital form.",
		definitionsContentTwo:
			router.locale === "ar-AE"
				? "١.٢. المصطلحات الأخرى المكتوبة بحروف كبيرة والمستخدمة هنا ولكن غير المعرفة في سياسة الخصوصية تحمل المعاني المحددة لها في شروط الاستخدام الموجودة في "
				: router.locale === "kn-IN"
					? "1.2. ಗೌಪ್ಯತಾ ನೀತಿಯಲ್ಲಿ ವಿವರಿಸಲಾಗಿರುವ ಆದಾಯಕ್ಕೆ ನಿರ್ವಚಿತ ಪದಗಳು ಇಲ್ಲಿನವುಗಳಿಗೆ ನೀಡಲಾಗಿದೆ. ಗೌಪ್ಯತಾ ನೀತಿಯ ನಿಯಮಗಳಲ್ಲಿ ವಿವರಿಸಲಾಗಿರುವ ಇತರ ಹೆಚ್ಚಿನ ಪದಗಳು ನಿಯಮಗಳಲ್ಲಿ ನಿರ್ಧಾರಿತವಾಗಿರುವ ಅರ್ಥವನ್ನು ಹೊಂದಿರುವವು."
					: "1.2. Other capitalized terms used herein but not defined in the Privacy Policy have the meaning assigned to them in the Terms of Use contained at ",
		personalinfo:
			router.locale === "ar-AE"
				? "٢. جمع المعلومات الشخصية"
				: router.locale === "kn-IN"
					? "2. ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ಸಂಗ್ರಹ"
					: "2. Collection of Personal Information",
		personalinfocontentone:
			router.locale === "ar-AE"
				? "٢.١. إذا كنت مستخدمًا وقد أنشأت حسابًا مع الشركة لاستخدام المنصة الإلكترونية، فقد نقوم بجمع معلوماتك الشخصية."
				: router.locale === "kn-IN"
					? "2.1. ನೀವು ಬಳಕೆಗೆ ಕಂಪನಿಯೊಂದಿಗೆ ಖಾತೆ ಉಂಟುಮಾಡಿದ್ದೀರಿ ಮತ್ತು ಆನ್‌ಲೈನ್ ಪ್ಲ್ಯಾಟ್‌ಫಾರ್ಮ್‌ನ ಬಳಕೆಗಾಗಿ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಸಂಗ್ರಹಿಸಬಹುದು."
					: "2.1. If you are a user and have created an account with the company for use of the online platform, we may collect your personal information.",
		personalinfocontenttwo:
			router.locale === "ar-AE"
				? "٢.٢. قد نقوم بجمع وتخزين واستخدام الأنواع التالية من المعلومات الشخصية:"
				: router.locale === "kn-IN"
					? "2.2. ನಾವು ಕೆಳಗಿನ ವಿಧಗಳಿಂದ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಸಂಗ್ರಹಿಸಬಹುದು, ಸಂಗ್ರಹಿಸಿದ್ದು ಮತ್ತು ಬಳಕೆ ಮಾಡಿದ್ದು ಕೆಲವು ವಿಧಗಳು:"
					: "2.2. We may collect, store, and use the following kinds of personal information:",
		personalinfocontenttwoListOne:
			router.locale === "ar-AE"
				? "معلومات عن جهاز الكمبيوتر الخاص بك وعن زياراتك واستخدامك لهذا الموقع الإلكتروني (بما في ذلك عنوان الـ IP الخاص بك، الموقع الجغرافي، نوع وإصدار المتصفح، نظام التشغيل، مدة الزيارة، الصفحات المشاهدة، ومسارات التنقل عبر الموقع الإلكتروني)؛"
				: router.locale === "kn-IN"
					? "ನಿಮ್ಮ ಕಂಪ್ಯೂಟರ್ ಮತ್ತು ಈ ವೆಬ್‌ಸೈಟ್‌ಗೆ ನೀವು ಹೋಗಿದ್ದೀರಿ ಎಂಬ ಮಾಹಿತಿ (ನಿಮ್ಮ IP ವಿಳಾಸ, ಭೌಗೋಳಿಕ ಸ್ಥಳ, ಬ್ರೌಸರ್ ಪ್ರಕಾರ ಮತ್ತು ಆವೃತ್ತಿ, ನಿರ್ವಹಣ ವ್ಯವಸ್ಥೆ, ಭೇಟಿಯ ದೈರ್ಘ್ಯ, ಪುಟ ವೀಕ್ಷಣೆಗಳು ಮತ್ತು ವೆಬ್‌ಸೈಟ್‌ನ ನಾವಿಗೆ ಹೋಗಿದ್ದ ಮಾರ್ಗಗಳು);"
					: "information about your computer and about your visits to and use of this website (including your IP address, geographical location, browser type and version, operating system, length of visit, page views, and website navigation paths);",
		personalinfocontenttwoListTwo:
			router.locale === "ar-AE"
				? "المعلومات التي تقدمها للشركة عند إنشاء حساب؛"
				: router.locale === "kn-IN"
					? "ಖಾತೆಯನ್ನು ರಚಿಸುವಾಗ ನೀವು ಕಂಪನಿಗೆ ಒದಗಿಸುವ ಮಾಹಿತಿ;"
					: "information that you provide to the company when creating an account;",
		personalinfocontenttwoListThree:
			router.locale === "ar-AE"
				? "المعلومات التي تقدمها للشركة عند استخدامك للخدمات؛"
				: router.locale === "kn-IN"
					? "ನೀವು ಈ ಸೇವೆಗಳನ್ನು ಬಳಸುವಾಗ ಕಂಪನಿಗೆ ಒದಗಿಸುವ ಮಾಹಿತಿ;"
					: "information that you provide to the company when using the services;",
		personalinfocontenttwoListFour:
			router.locale === "ar-AE"
				? "المعلومات المتعلقة بالخدمة التي تم شراؤها أو أي معاملات أخرى تقوم بها من خلال الموقع الإلكتروني؛ و"
				: router.locale === "kn-IN"
					? "ಖರೀದಿಸಿದ ಸೇವೆ ಅಥವಾ ವೆಬ್‌ಸೈಟ್ ಮೂಲಕ ನೀವು ಪ್ರವೇಶಿಸುವ ಯಾವುದೇ ಇತರ ವಹಿವಾಟುಗಳಿಗೆ ಸಂಬಂಧಿಸಿದ ಮಾಹಿತಿ; ಮತ್ತು"
					: "information relating to the service purchased or any other transactions that you enter into through the website; and",
		personalinfocontenttwoListFive:
			router.locale === "ar-AE"
				? "معلومات أخرى يتم جمعها خلال تفاعلك مع المنصة الإلكترونية."
				: router.locale === "kn-IN"
					? "ಆನ್‌ಲೈನ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ನೊಂದಿಗೆ ನಿಮ್ಮ ಸಂವಾದದ ಸಮಯದಲ್ಲಿ ಸಂಗ್ರಹಿಸಲಾದ ಇತರ ಮಾಹಿತಿ."
					: "other information that is collected during your interaction with the online platform.",
		personalinfocontentthree:
			router.locale === "ar-AE"
				? `٢.٣. مثل أي موقع ويب آخر، تستخدم الشركة "ملفات تعريف الارتباط" (الكوكيز). يتم استخدام هذه الملفات لتخزين المعلومات، بما في ذلك تفضيلات الزوار والصفحات التي تم الوصول إليها أو زيارتها على الموقع. تُستخدم هذه المعلومات لتحسين تجربة المستخدم من خلال تخصيص محتوى الصفحة بناءً على نوع متصفح الزائر و/أو معلومات أخرى.`
				: router.locale === "kn-IN"
					? "2.3. ಯಾವುದೇ ಇತರ ವೆಬ್‌ಸೈಟ್‌ಗೆ ಹೋಗಿ ನೀವು ಅವುಗಳ ಗೌಪ್ಯತಾ ಅಭ್ಯಾಸಗಳಿಗೆ ಅನ್ವಯವಾಗುವದಿಲ್ಲ. ಈ ನೀತಿಯ ಅನ್ವಯವಾದ ವೆಬ್‌ಸೈಟ್‌ಗಳ ಗೌಪ್ಯತಾ ನೀತಿಗಳನ್ನು ಮನಸಾರಾಗಿ ಓದಿ. ನಾವು ಈ ಮೂರನೇ ಪಕ್ಷದ ಸೈಟ್‌ಗಳಿಗೆ ಹೊಂದಿದ್ದೇವೆ."
					: "2.3. Like any other website, the company uses 'cookies'. These cookies are used to store information, including visitors' preferences and the pages on the website that the visitor accessed or visited. The information is used to optimize the user's experience by customizing the web page content based on the visitor's browser type and/or other information.",
		personalinfocontentfour:
			router.locale === "ar-AE"
				? "٢.٤. من خلال إنشاء حساب مع الشركة أو باستخدام المنصة الإلكترونية، فإنك توافق على جمع واستخدام والكشف عن المعلومات الشخصية من قبل الشركة وفقًا لهذه السياسة الخصوصية."
				: router.locale === "kn-IN"
					? "2.4. ಕಂಪನಿಯೊಂದಿಗೆ ಖಾತೆ ಉಂಟುಮಾಡಿದ್ದೀರಿ ಅಥವಾ ಆನ್‌ಲೈನ್ ಪ್ಲ್ಯಾಟ್‌ಫಾರ್ಮ್‌ನ ಬಳಕೆಗಾಗಿ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ಸಂಗ್ರಹ, ಬಳಕೆ, ಮತ್ತು ಬಯಕೆಯನ್ನು ಕಂಪನಿಯ ಗೌಪ್ಯತಾ ನೀತಿಯಂತೆ ನಡೆಸುವುದಕ್ಕಾಗಿ ನೀವು ಒಪ್ಪಿದರೆ."
					: "2.4. By creating an account with the company or by using the online platform, you consent to the collection, use, and disclosure of personal information by the company in accordance with this privacy policy.",

		purpose:
			router.locale === "ar-AE"
				? "٣. الغرض، الإلغاء والسحب"
				: router.locale === "kn-IN"
					? "3. ಉದ್ದೇಶ, ಬಿಡುಗಡೆ ಮತ್ತು ತಿರಸ್ಕರಣೆ"
					: "3. Purpose, Opt Out and Withdrawal",
		purposecontentone:
			router.locale === "ar-AE"
				? "٣.١. نستخدم المعلومات الشخصية التي تم جمعها منك بطرق متنوعة، بما في ذلك على سبيل المثال لا الحصر:"
				: router.locale === "kn-IN"
					? " 3.1. ನಾವು ನಿಮ್ಮಿಂದ ಸಂಗ್ರಹಿಸಿದ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ವಿವಿಧ ವಿಧಗಳಲ್ಲಿ ಬಳಕೆಗೆ ಹೊಂದಿಸುತ್ತೇವೆ, ಅದರಲ್ಲಿ ನಿಗದಿತವಾದ ಆದೇಶಗಳು ಮತ್ತು ನಿಯಮಗಳು ಸೇರಿವೆ:"
					: "3.1. We use the personal information collected from you in various ways, including but not limited to:",
		purposecontentoneListOne:
			router.locale === "ar-AE"
				? "تشغيل وصيانة الموقع الإلكتروني؛"
				: router.locale === "kn-IN"
					? "ವೆಬ್‌ಸೈಟ್ ಅನ್ನು ನಿರ್ವಹಿಸಿ ಮತ್ತು ನಿರ್ವಹಿಸಿ;"
					: "Operate and maintain the website;",
		purposecontentoneListTwo:
			router.locale === "ar-AE"
				? "إنشاء وإدارة الحساب؛"
				: router.locale === "kn-IN"
					? "ಖಾತೆಯನ್ನು ರಚಿಸಿ ಮತ್ತು ನಿರ್ವಹಿಸಿ;"
					: "Create and manage the account;",
		purposecontentoneListThree:
			router.locale === "ar-AE"
				? "تقديم الخدمات؛"
				: router.locale === "kn-IN"
					? "ಸೇವೆಗಳನ್ನು ಒದಗಿಸಿ;"
					: "Provide Services;",
		purposecontentoneListFour:
			router.locale === "ar-AE"
				? "يمكنك في أي وقت، من خلال كتابة رسالة إلى الشركة على عنوان البريد الإلكتروني المقدم أدناه، سحب موافقتك على جمع واستخدام والكشف ونقل المعلومات الشخصية من قبل الشركة وفقًا لهذه السياسة الخصوصية."
				: router.locale === "kn-IN"
					? "ಈ ಗೌಪ್ಯತಾ ನೀತಿಗೆ ಅನುಸಾರವಾಗಿ ಕಂಪನಿಯು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ಸಂಗ್ರಹಣೆ, ಬಳಕೆ, ಬಹಿರಂಗಪಡಿಸುವಿಕೆ ಮತ್ತು ವರ್ಗಾವಣೆಗಾಗಿ ನಿಮ್ಮ ಒಪ್ಪಿಗೆಯನ್ನು ನೀವು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ, ಕೆಳಗೆ ಒದಗಿಸಿದ ಇಮೇಲ್ ವಿಳಾಸದಲ್ಲಿ ಕಂಪನಿಗೆ ಬರೆಯುವ ಮೂಲಕ ಹಿಂಪಡೆಯಬಹುದು."
					: "You may, at any time, by writing to the company at the email address provided below, withdraw your consent for the collection, use, disclosure, and transfer of personal information by the company in accordance with this privacy policy.",
		purposecontentoneListFive:
			router.locale === "ar-AE"
				? "فهم وتحليل كيفية استخدامك للموقع الإلكتروني"
				: router.locale === "kn-IN"
					? "ನೀವು ವೆಬ್‌ಸೈಟ್ ಅನ್ನು ಹೇಗೆ ಬಳಸುತ್ತೀರಿ ಎಂಬುದನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ ಮತ್ತು ವಿಶ್ಲೇಷಿಸಿ"
					: "Understand and analyze how you use the website",
		purposecontentoneListSix:
			router.locale === "ar-AE"
				? "تطوير منتجات وخدمات وميزات ووظائف جديدة؛"
				: router.locale === "kn-IN"
					? "ಹೊಸ ಉತ್ಪನ್ನಗಳು, ಸೇವೆಗಳು, ವೈಶಿಷ್ಟ್ಯಗಳು ಮತ್ತು ಕ್ರಿಯಾತ್ಮಕತೆಯನ್ನು ಅಭಿವೃದ್ಧಿಪಡಿಸಿ;"
					: "Develop new products, services, features, and functionality;",
		purposecontentoneListSeven:
			router.locale === "ar-AE"
				? "التواصل معك، إما مباشرة أو من خلال أحد الشركاء، بما في ذلك لخدمة العملاء، لتزويدك بالتحديثات ومعلومات أخرى تتعلق بالموقع الإلكتروني، ولأغراض التسويق والترويج؛"
				: router.locale === "kn-IN"
					? "ವೆಬ್‌ಸೈಟ್‌ಗೆ ಸಂಬಂಧಿಸಿದ ನವೀಕರಣಗಳು ಮತ್ತು ಇತರ ಮಾಹಿತಿಯನ್ನು ನಿಮಗೆ ಒದಗಿಸಲು ಮತ್ತು ಮಾರ್ಕೆಟಿಂಗ್ ಮತ್ತು ಪ್ರಚಾರದ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಗ್ರಾಹಕ ಸೇವೆ ಸೇರಿದಂತೆ ನೇರವಾಗಿ ಅಥವಾ ಪಾಲುದಾರರಲ್ಲಿ ಒಬ್ಬರ ಮೂಲಕ ನಿಮ್ಮೊಂದಿಗೆ ಸಂವಹನ ನಡೆಸಿ;"
					: "Communicate with you, either directly or through one of the partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes;",
		purposecontentoneListEight:
			router.locale === "ar-AE"
				? "إرسال رسائل بريد إلكتروني، رسائل نصية قصيرة (SMS)، أو إجراء مكالمات هاتفية (بما في ذلك المكالمات الهاتفية الآلية). قد يتم تسجيل المكالمات الهاتفية لأغراض التدريب والجودة، بالإضافة إلى تحسين خدمة العملاء."
				: router.locale === "kn-IN"
					? "ನಿಮಗೆ ಇಮೇಲ್‌ಗಳು, SMS ಕಳುಹಿಸಿ ಅಥವಾ ದೂರವಾಣಿ ಕರೆಗಳನ್ನು ಮಾಡಿ (ಸ್ವಯಂಚಾಲಿತ ಫೋನ್ ಕರೆಗಳು ಸೇರಿದಂತೆ). ತರಬೇತಿ ಮತ್ತು ಗುಣಮಟ್ಟದ ಉದ್ದೇಶಗಳಿಗಾಗಿ, ಹಾಗೆಯೇ ಗ್ರಾಹಕ ಸೇವೆಯನ್ನು ಸುಧಾರಿಸಲು ದೂರವಾಣಿ ಕರೆಗಳನ್ನು ರೆಕಾರ್ಡ್ ಮಾಡಬಹುದು."
					: "Send you emails, SMS, or make telephone calls (including automated phone calls). Telephone calls may be recorded for training and quality purposes, as well as to improve customer service.",
		purposecontentoneListNine:
			router.locale === "ar-AE"
				? "عرض الإعلانات ذات الصلة؛ و"
				: router.locale === "kn-IN"
					? "ಸಂಬಂಧಿತ ಜಾಹೀರಾತುಗಳನ್ನು ಒದಗಿಸಿ; ಮತ್ತು"
					: "serve relevant advertisements; and",
		purposecontentoneListTen:
			router.locale === "ar-AE"
				? "اكتشاف ومنع الاحتيال."
				: router.locale === "kn-IN"
					? "ವಂಚನೆಯನ್ನು ಹುಡುಕಿ ಮತ್ತು ತಡೆಯಿರಿ."
					: "Find and prevent fraud.",
		purposecontenttwo:
			router.locale === "ar-AE"
				? "٣.٢. إذا اخترت المشاركة في أي نشاط يُعرض من خلال المنصة الإلكترونية أو استفدت من أي ميزة تُعرض من خلالها، فقد يُطلب منك تقديم بعض المعلومات الشخصية للشركة: لتمكينك من استخدام تلك الخدمات، أو لتوفير الخدمات التي تم شراؤها منك، أو لإرسال الفواتير وجمع المدفوعات منك، أو لإرسال إشعارات البريد الإلكتروني، والمعلومات التسويقية، والاتصالات الأخرى التي طلبتها بشكل محدد، أو للتعامل مع الاستفسارات أو الشكاوى المقدمة من قبلك أو عنك المتعلقة باستخدام الموقع الإلكتروني أو الخدمات التي تم شراؤها منك، أو للامتثال لأحكام القوانين المعمول بها."
				: router.locale === "kn-IN"
					? "3.2. ಆನ್‌ಲೈನ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಮೂಲಕ ನೀಡಲಾಗುವ ಯಾವುದೇ ಚಟುವಟಿಕೆಯಲ್ಲಿ ಭಾಗವಹಿಸಲು ಅಥವಾ ಆನ್‌ಲೈನ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಮೂಲಕ ನೀಡಲಾಗುವ ಯಾವುದೇ ವೈಶಿಷ್ಟ್ಯದ ಲಾಭವನ್ನು ಪಡೆಯಲು ನೀವು ಆಯ್ಕೆ ಮಾಡಿದರೆ, ನೀವು ಕಂಪನಿಗೆ ಕೆಲವು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಒದಗಿಸಬೇಕಾಗಬಹುದು: ಅಂತಹ ಸೇವೆಗಳ ಬಳಕೆಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲು ನೀವು, ಅಥವಾ ನೀವು ಖರೀದಿಸಿದ ಸೇವೆಗಳ ಪೂರೈಕೆಗಾಗಿ, ಅಥವಾ ಇನ್‌ವಾಯ್ಸ್‌ಗಳನ್ನು ಕಳುಹಿಸಲು ಮತ್ತು ನಿಮ್ಮಿಂದ ಪಾವತಿಗಳನ್ನು ಸಂಗ್ರಹಿಸಲು, ಅಥವಾ ಇಮೇಲ್ ಅಧಿಸೂಚನೆಗಳನ್ನು ಕಳುಹಿಸಲು, ಮಾರ್ಕೆಟಿಂಗ್ ಮಾಹಿತಿ ಮತ್ತು ನೀವು ನಿರ್ದಿಷ್ಟವಾಗಿ ವಿನಂತಿಸಿದ ಇತರ ಸಂವಹನಗಳನ್ನು ಕಳುಹಿಸಲು ಅಥವಾ ಮಾಡಿದ ವಿಚಾರಣೆಗಳು ಅಥವಾ ದೂರುಗಳೊಂದಿಗೆ ವ್ಯವಹರಿಸಲು ಅಥವಾ ವೆಬ್‌ಸೈಟ್‌ನ ಬಳಕೆಗೆ ಅಥವಾ ನೀವು ಖರೀದಿಸಿದ ಸೇವೆಗಳಿಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ಅಥವಾ ಅನ್ವಯಿಸುವ ಕಾನೂನುಗಳ ನಿಬಂಧನೆಗಳನ್ನು ಅನುಸರಿಸಲು ನಿಮ್ಮ ಬಗ್ಗೆ."
					: "3.2. If you choose to participate in any activity that is offered through the online platform or take advantage of any feature that is offered through the online platform, you may be required to furnish some personal information to the company: to enable the use of such services by you, or for the supply of services purchased by you, or to send invoices and collect payments from you, or to send email notifications, marketing information, and other communications that you have specifically requested, or to deal with inquiries or complaints made by or about you relating to the use of the website or the services purchased by you, or to comply with the provisions of applicable laws.",
		purposecontentthree:
			router.locale === "ar-AE"
				? "٣.٣. يمكنك رفض تقديم المعلومات الشخصية التي يتم طلبها منك، ولكن قد يؤثر ذلك على قدرتنا في تقديم الخدمات والمنتجات التي طلبتها أو السماح لك بالمشاركة في أي نشاط يُعرض على المنصة الإلكترونية."
				: router.locale === "kn-IN"
					? "3.3. ನಿಮ್ಮಿಂದ ವಿನಂತಿಸಿದ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಒದಗಿಸಲು ನೀವು ನಿರಾಕರಿಸಬಹುದು, ಆದರೆ ಇದು ವಿನಂತಿಸಿದ ಸೇವೆಗಳು ಮತ್ತು ಉತ್ಪನ್ನಗಳನ್ನು ನಿಮಗೆ ಒದಗಿಸುವ ಅಥವಾ ಆನ್‌ಲೈನ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ನಲ್ಲಿ ನೀಡಲಾಗುವ ಯಾವುದೇ ಚಟುವಟಿಕೆಯಲ್ಲಿ ನಿಮ್ಮ ಭಾಗವಹಿಸುವಿಕೆಯನ್ನು ಅನುಮತಿಸುವ ನಮ್ಮ ಸಾಮರ್ಥ್ಯದ ಮೇಲೆ ಪರಿಣಾಮ ಬೀರಬಹುದು"
					: "3.3. You may decline to provide personal information that is requested from you, but this may affect our ability to provide to you the services and products requested or to allow your participation in any activity that is offered on the online platform.",
		purposecontentfour:
			router.locale === "ar-AE"
				? "٣.٤. يمكنك في أي وقت، من خلال كتابة رسالة إلى الشركة على عنوان البريد الإلكتروني المقدم أدناه، سحب موافقتك على جمع واستخدام وكشف ونقل المعلومات الشخصية من قبل الشركة وفقًا لهذه السياسة الخصوصية."
				: router.locale === "kn-IN"
					? "3.4 ಈ ಗೌಪ್ಯತಾ ನೀತಿಗೆ ಅನುಸಾರವಾಗಿ ಕಂಪನಿಯು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ಸಂಗ್ರಹಣೆ, ಬಳಕೆ, ಬಹಿರಂಗಪಡಿಸುವಿಕೆ ಮತ್ತು ವರ್ಗಾವಣೆಗಾಗಿ ನಿಮ್ಮ ಒಪ್ಪಿಗೆಯನ್ನು ನೀವು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ, ಕೆಳಗೆ ಒದಗಿಸಿದ ಇಮೇಲ್ ವಿಳಾಸದಲ್ಲಿ ಕಂಪನಿಗೆ ಬರೆಯುವ ಮೂಲಕ ಹಿಂಪಡೆಯಬಹುದು."
					: "3.4. You may, at any time, by writing to the company at the email address provided below, withdraw your consent for the collection, use, disclosure, and transfer of personal information by the company in accordance with this privacy policy.",
		disclosure:
			router.locale === "ar-AE"
				? "٤. الكشف والنقل"
				: router.locale === "kn-IN"
					? "4. ವಿವರಣೆ ಮತ್ತು ಬದಲಾವಣೆ"
					: "4. Disclosure and Transfer",
		disclosurecontentone:
			router.locale === "ar-AE"
				? "٤.١. قد يتم الكشف عن المعلومات الشخصية لشركاء الشركة والتابعين لها لتقديم المنتجات والخدمات التي قد تكون ذات اهتمام لك."
				: router.locale === "kn-IN"
					? "4.1. ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ನಿಮಗೆ ಆಸಕ್ತವಾಗಿರಬಹುದಾದ ಉತ್ಪಾದನಗಳನ್ನು ವಹಿಸಲು ಕಂಪನಿಯ ಭಾಗಿಗಳು ಮತ್ತು ಸಹಯೋಗಿಗಳಿಗೆ ವಿವರಿಸಲಾಗಬಹುದು."
					: "4.1. Personal information may be disclosed to the company's partners and associates to deliver products and services that may be of interest to you.",
		disclosurecontenttwo:
			router.locale === "ar-AE"
				? "٤.٢. قد يتم استضافة المعلومات الشخصية في مركز بيانات تابع لطرف ثالث، وقد تكون الخوادم موجودة في مناطق خارج الهند. أنت تقر بأن البيانات المخزنة في مراكز البيانات الواقعة خارج الهند قد تخضع لقوانين الولاية القضائية التي يقع فيها مركز البيانات. أنت توافق تحديدًا على نقل المعلومات الشخصية إلى مراكز البيانات أو الخوادم التي تشغلها مزودات الخدمة من طرف ثالث وتقع في مناطق خارج الهند التي قد لا تحتوي على قوانين وتنظيمات مماثلة بشأن حماية المعلومات الشخصية."
				: router.locale === "kn-IN"
					? "4.2. ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಡೇಟಾ ಕೇಂದ್ರದಿಂದ ಹೋಸ್ಟ್ ಮಾಡಬಹುದು ಮತ್ತು ಸರ್ವರ್‌ಗಳು ಭಾರತದ ಹೊರಗಿನ ನ್ಯಾಯವ್ಯಾಪ್ತಿಯಲ್ಲಿ ನೆಲೆಗೊಂಡಿರಬಹುದು. ಭಾರತದ ಹೊರಗೆ ಇರುವ ಡೇಟಾ ಸೆಂಟರ್‌ಗಳಲ್ಲಿ ಸಂಗ್ರಹವಾಗಿರುವ ಡೇಟಾವು ಡೇಟಾ ಸೆಂಟರ್ ಇರುವ ನ್ಯಾಯವ್ಯಾಪ್ತಿಯ ಕಾನೂನುಗಳಿಂದ ನಿಯಂತ್ರಿಸಲ್ಪಡುತ್ತದೆ ಎಂದು ನೀವು ಅಂಗೀಕರಿಸಿದ್ದೀರಿ. ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ರಕ್ಷಣೆಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ಸಮಾನವಾದ ಕಾನೂನುಗಳು ಮತ್ತು ನಿಬಂಧನೆಗಳನ್ನು ಹೊಂದಿರದ ಭಾರತದ ಹೊರಗಿನ ಪ್ರದೇಶಗಳಲ್ಲಿ ನೆಲೆಗೊಂಡಿರುವ ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಸೇವಾ ಪೂರೈಕೆದಾರರು ನಿರ್ವಹಿಸುವ ಡೇಟಾ ಕೇಂದ್ರಗಳು ಅಥವಾ ಸರ್ವರ್‌ಗಳಿಗೆ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ವರ್ಗಾಯಿಸಲು ನೀವು ನಿರ್ದಿಷ್ಟವಾಗಿ ಸಮ್ಮತಿಸುತ್ತೀರಿ."
					: "4.2.  Personal information may be hosted by a third-party data center, and the servers may be located in jurisdictions outside India. You acknowledge that the data stored in data centers located outside India may be governed by the laws of the jurisdiction in which the data center is located. You specifically consent to the transfer of personal information to the data centers or servers operated by third-party service providers located in territories outside India that may not have equivalent laws and regulations regarding the protection of personal information.",
		disclosurecontentthree:
			router.locale === "ar-AE"
				? "٤.٣. قد نكشف عن المعلومات الشخصية على النحو التالي:"
				: router.locale === "kn-IN"
					? "4.3. ನಾವು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಈ ಕೆಳಗಿನಂತೆ ಬಹಿರಂಗಪಡಿಸಬಹುದು:"
					: "4.3. We may disclose personal information as follows:",
		disclosurecontentthreeListOne:
			router.locale === "ar-AE"
				? "إلى شركاء الشركة وموظفيها الذين يوافقون على التعامل معها وفقًا لهذه السياسة الخصوصية."
				: router.locale === "kn-IN"
					? " ಈ ಗೌಪ್ಯತಾ ನೀತಿಗೆ ಅನುಸಾರವಾಗಿ ಅದನ್ನು ಪರಿಗಣಿಸಲು ಒಪ್ಪಿಕೊಳ್ಳುವ ಕಂಪನಿಯ ಪಾಲುದಾರರು ಮತ್ತು ಸಹವರ್ತಿಗಳಿಗೆ."
					: " To the company's partners and associates that agree to treat it in accordance with this privacy policy.",
		disclosurecontentthreeListTwo:
			router.locale === "ar-AE"
				? "إلى مزودي الخدمة والشركاء الآخرين الذين يدعمون أعمال الشركة، شريطة أن يوافق جميع هؤلاء الأطراف الثالثة على عدم استخدام المعلومات الشخصية لأغراض أخرى غير تلك التي تم الكشف عنها من أجلها."
				: router.locale === "kn-IN"
					? " ಒದಗಿಸಿದ ಕಂಪನಿಯ ವ್ಯವಹಾರವನ್ನು ಬೆಂಬಲಿಸುವ ಸೇವಾ ಪೂರೈಕೆದಾರರು ಮತ್ತು ಇತರ ಪಾಲುದಾರರಿಗೆ, ಆದಾಗ್ಯೂ, ಅಂತಹ ಎಲ್ಲಾ ಮೂರನೇ ವ್ಯಕ್ತಿಗಳು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಬಹಿರಂಗಪಡಿಸಿದ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಬಳಸದಿರಲು ಒಪ್ಪುತ್ತಾರೆ."
					: " To service providers and other partners who support the business of the company, provided, however, all such third parties agree not to use the personal information for purposes other than those for which it is disclosed.",
		disclosurecontentthreeListThree:
			router.locale === "ar-AE"
				? "إلى مشتري أو كيان خليفة في سياق بيع أو اندماج أو تخصيص أو أي نقل آخر للشركة أو أي من شركاتها التابعة، أو قسم تجاري من الشركة أو أي من شركاتها التابعة، أو بيع جزء كبير من أصول الشركة أو أي من شركاتها التابعة."
				: router.locale === "kn-IN"
					? " ಕಂಪನಿಯ ಅಥವಾ ಅದರ ಯಾವುದೇ ಅಂಗಸಂಸ್ಥೆಗಳ ಮಾರಾಟ, ವಿಲೀನ, ನಿಯೋಜನೆ ಅಥವಾ ಇತರ ವರ್ಗಾವಣೆ ಅಥವಾ ಕಂಪನಿಯ ವ್ಯಾಪಾರ ವಿಭಾಗ ಅಥವಾ ಅದರ ಯಾವುದೇ ಅಂಗಸಂಸ್ಥೆಗಳು ಅಥವಾ ಗಣನೀಯವಾಗಿ ಎಲ್ಲಾ ಆಸ್ತಿಗಳ ಮಾರಾಟಕ್ಕೆ ಸಂಬಂಧಿಸಿದಂತೆ ಖರೀದಿದಾರ ಅಥವಾ ಉತ್ತರಾಧಿಕಾರಿ ಘಟಕಕ್ಕೆ ಕಂಪನಿ ಅಥವಾ ಅದರ ಯಾವುದೇ ಅಂಗಸಂಸ್ಥೆಗಳು."
					: " To a purchaser or successor entity in connection with the sale, merger, assignment, or other transfer of the company or any of its affiliates, or a business division of the company or any of its affiliates, or the sale of substantially all of the assets of the company or any of its affiliates.",
		disclosurecontentthreeListFour:
			router.locale === "ar-AE"
				? "إذا كان الكشف مطلوبًا بموجب قانون أو قاعدة أو لائحة أو أمر من محكمة ذات اختصاص قضائي أو سلطة حكومية أو سلطة تنظيمية."
				: router.locale === "kn-IN"
					? " ಕಾನೂನು, ನಿಯಮ, ನಿಯಂತ್ರಣ, ಅಥವಾ ಸಕ್ಷಮ ನ್ಯಾಯವ್ಯಾಪ್ತಿಯ ನ್ಯಾಯಾಲಯದ ಆದೇಶ, ಸರ್ಕಾರಿ ಪ್ರಾಧಿಕಾರ ಅಥವಾ ನಿಯಂತ್ರಕ ಪ್ರಾಧಿಕಾರದ ಮೂಲಕ ಬಹಿರಂಗಪಡಿಸುವಿಕೆ ಅಗತ್ಯವಿದ್ದರೆ,"
					: " If the disclosure is required by law, rule, regulation, or order of a court of competent jurisdiction, governmental authority, or regulatory authority,",
		disclosurecontentthreeListFive:
			router.locale === "ar-AE"
				? "لتنفيذ سياسة الخصوصية هذه."
				: router.locale === "kn-IN"
					? "ಈ ಗೌಪ್ಯತೆ ನೀತಿಯನ್ನು ಜಾರಿಗೊಳಿಸಲು."
					: "To enforce this privacy policy.",
		disclosurecontentfour:
			router.locale === "ar-AE"
				? `٤.٤. مواقع الطرف الثالث إذا قمت بالنقر على أحد الروابط إلى مواقع ويب تابعة لأطراف ثالثة، فقد يتم توجيهك إلى مواقع لا نتحكم فيها. لا تنطبق هذه السياسة على ممارسات الخصوصية لتلك المواقع. اقرأ سياسات الخصوصية للمواقع الأخرى بعناية. نحن غير مسؤولين عن هذه المواقع التابعة لأطراف ثالثة.`
				: router.locale === "kn-IN"
					? "4.4. ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಸೈಟ್‌ಗಳು ಮೂರನೇ ವ್ಯಕ್ತಿಯ ವೆಬ್‌ಸೈಟ್‌ಗಳಿಗೆ ನೀವು ಲಿಂಕ್‌ಗಳಲ್ಲಿ ಒಂದನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿದರೆ, ನಾವು ನಿಯಂತ್ರಿಸದ ವೆಬ್‌ಸೈಟ್‌ಗಳಿಗೆ ನಿಮ್ಮನ್ನು ಕರೆದೊಯ್ಯಬಹುದು. ಈ ನೀತಿಯು ಆ ವೆಬ್‌ಸೈಟ್‌ಗಳ ಗೌಪ್ಯತೆ ಅಭ್ಯಾಸಗಳಿಗೆ ಅನ್ವಯಿಸುವುದಿಲ್ಲ. ಇತರ ವೆಬ್‌ಸೈಟ್‌ಗಳ ಗೌಪ್ಯತೆ ನೀತಿಗಳನ್ನು ಎಚ್ಚರಿಕೆಯಿಂದ ಓದಿ. ಈ ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಸೈಟ್‌ಗಳಿಗೆ ನಾವು ಜವಾಬ್ದಾರರಾಗಿರುವುದಿಲ್ಲ"
					: "4.4. Third-party sites If you click on one of the links to third-party websites, you may be taken to websites we do not control. This policy does not apply to the privacy practices of those websites. Read the privacy policies of other websites carefully. We are not responsible for these third-party sites.",
		contactcompany:
			router.locale === "ar-AE"
				? "٥. كيفية الاتصال بالشركة / موظف الشكاوى في الشركة"
				: router.locale === "kn-IN"
					? "5.ಕಂಪನಿಯ ಕಂಪನಿ / ಕುಂದುಕೊರತೆ ಅಧಿಕಾರಿಯನ್ನು ಹೇಗೆ ಸಂಪರ್ಕಿಸುವುದು"
					: "5. How to Contact the Company / Grievance Officer of the Company",
		contactcompanycontent:
			router.locale === "ar-AE"
				? "٥.١. إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه أو إذا كنت ترغب في الاتصال بالشركة بشأن استخدام أو كشف المعلومات الشخصية، يرجى الاتصال بنا عن طريق إرسال بريد إلكتروني أو رسالة إلى:"
				: router.locale === "kn-IN"
					? "5.1. ಈ ಗೌಪ್ಯತಾ ನೀತಿಯ ಬಳಕೆ ಅಥವಾ ವ್ಯಕ್ತಿಗಳ ಮಾಹಿತಿಯ ವಿಮರ್ಶೆಯ ಬಗ್ಗೆ ಪ್ರಶ್ನೆಗಳಿದ್ದಲ್ಲಿ ಕಂಪನಿಯನ್ನು ಸಂಪರ್ಕಿಸಲು ದಯವಿಟ್ಟು ಈ ಇಮೇಲ್ ಅಥವಾ ಪತ್ರವನ್ನು ಕಳುಹಿಸಿ:"
					: "5.1. If you have questions about this privacy policy or wish to contact the company in connection with the use or disclosure of personal information, please contact us by sending an email or a letter to:",
		contactcompanycontenTo:
			router.locale === "ar-AE"
				? "إلى: بيغرو ريال إستيت برايفت ليمتد"
				: router.locale === "kn-IN"
					? "ಇವರಿಗೆ: ಬೀಗ್ರು ರಿಯಲ್ ಎಸ್ಟೇಟ್ ಪ್ರೈವೇಟ್ ಲಿಮಿಟೆಡ್"
					: "To: Beegru Real Estate Private Limited",
		contactcompanycontentAttention:
			router.locale === "ar-AE"
				? "إلى: القسم القانوني"
				: router.locale === "kn-IN"
					? " ಗಮನ: ಕಾನೂನು"
					: "Attention: Legal",
		contactcompanycontentAddress:
			router.locale === "ar-AE"
				? "العنوان: # 455/7، الشارع 15، لاكاساندر، بنغالور 560030"
				: router.locale === "kn-IN"
					? "ವಿಳಾಸ: # 455/7, 15 ನೇ ಮುಖ್ಯ, ಲಕ್ಕಸಂದ್ರ, ಬೆಂಗಳೂರು 560030"
					: "Address: # 455/7, 15 th Main, Lakkasandra, Bangalore 560030",
		contactcompanycontentTelephone:
			router.locale === "ar-AE"
				? "رقم الهاتف: +٩١ ٧٨٢٩٣ ٧١٩٩"
				: router.locale === "kn-IN"
					? "ದೂರವಾಣಿ: +91 78293 7199"
					: "Telephone: +91 78293 7199",
		contactcompanycontentEmail:
			router.locale === "ar-AE"
				? "البريد الإلكتروني: mail@beegru.com"
				: router.locale === "kn-IN"
					? "ಇಮೇಲ್: mail@beegru.com"
					: "Email: mail@beegru.com",
		contactcompanycontenttwo:
			router.locale === "ar-AE"
				? `٥.٢. موظف الشكاوى، كما هو مطلوب بموجب قانون تكنولوجيا المعلومات لعام ٢٠٠٠، هو سيدانت فينشركار على البريد الإلكتروني <mail@beegru.com>`
				: router.locale === "kn-IN"
					? " 5.2. ಗೌಪ್ಯತಾ ನೀತಿ ಅಧಿನಿಯಮದ ಅಧಿಕಾರಿ, 2000, ಅಧಿಕಾರಿಯಾಗಿ ಸಿದ್ಧಾಂತ್ ವಿಂಚುರ್ಕರ್ ಇವರು <mail@beegru.com> ಇದ್ದಾರೆ."
					: "5.2. Grievance Officer, as required under the Information Technology Act, 2000, is Siddanth Vinchurkar at <mail@beegru.com>",
		updates: router.locale === "ar-AE" ? "٦. التحديثات" : router.locale === "kn-IN" ? "6. ನವೀಕರಣಗಳು" : "6. Updates",
		updatecontentone:
			router.locale === "ar-AE"
				? "٦.١. تحتفظ الشركة بالحق في تعديل سياسة الخصوصية هذه دون موافقتك. قد تقوم الشركة بإبلاغ المستخدمين بشأن التعديلات على سياسة الخصوصية عن طريق عرض بيان على شكل لافتة على المنصة الإلكترونية أو تضمين بيان بشأن التعديلات في أسفل سياسة الخصوصية هذه. إذا واصلت استخدام المنصة الإلكترونية بعد نشر المعلومات المتعلقة بالتعديلات، فسيتم اعتبارك قد قبلت سياسة الخصوصية المعدلة."
				: router.locale === "kn-IN"
					? "6.1. ಕಂಪನಿ ನಿಮ್ಮ ಅನುಮತಿಯಿಲ್ಲದೆ ಈ ಗೌಪ್ಯತಾ ನೀತಿಯನ್ನು ಬದಲಾಯಿಸಲು ಹಕ್ಕನ್ನು ಕಾಯ್ದುಕೊಳ್ಳುತ್ತದೆ. ಕಂಪನಿ ಬದಲಾವಣೆಗಳ ಬಗ್ಗೆ ಬಳಕೆದಾರರನ್ನು ಮಾಹಿತಿಸಲು ಬಯಸಿದರೆ, ಆನ್‌ಲೈನ್ ಪ್ಲ್ಯಾಟ್‌ಫಾರ್ಮ್‌ನಲ್ಲಿ ಬ್ಯಾನರ್ ವಾಕ್ಯವನ್ನು ಪ್ರದರ್ಶಿಸಿದರು ಅಥವಾ ಈ ಗೌಪ್ಯತಾ ನೀತಿಯ ಕೆಳಗೆ ಬದಲಾವಣೆಗಳ ಬಗ್ಗೆ ಹೇಳಿದ ವಾಕ್ಯವನ್ನು ಸೇರಿಸಿದರು. ಬದಲಾವಣೆಗಳ ಬಗ್ಗೆ ಮಾಹಿತಿ ಪ್ರಕಟವಾಗಿದ್ದರೆ, ನೀವು ಮಾಹಿತಿಯನ್ನು ಪ್ರಕಟಿಸಿದ ನಂತರ ಆನ್‌ಲೈನ್ ಪ್ಲ್ಯಾಟ್‌ಫಾರ್ಮ್‌ನಲ್ ಬಳಕೆಯನ್ನು ಮುಂದುವರಿಸಿದರೆ, ನೀವು ಸರಿಯಾಗಿ ಬದಲಾವಣೆಯನ್ನು ಒಪ್ಪಿದಂತಾಗುತ್ತೀರಿ."
					: "6.1. The company reserves the right to modify this privacy policy without your consent. The company may inform the users regarding modifications to the privacy policy by displaying a banner statement on the online platform or including a statement regarding modifications at the bottom of this privacy policy. If you continue to use the online platform after information regarding the modifications is published, you shall be deemed to have accepted the revised privacy policy.",
		updatecontenttwo:
			router.locale === "ar-AE"
				? "٦.٢. تم آخر تحديث لهذه السياسة الخصوصية في ١٣ أكتوبر ٢٠٢٢."
				: router.locale === "kn-IN"
					? "6.2. ಈ ಗೌಪ್ಯತಾ ನೀತಿ ಕೊನೆಯ ಬಾರಿ ಅಕ್ಟೋಬರ್ 13, 2022 ರಂದು ನವೀಕರಿಸಲಾಯಿತು."
					: "6.2. This privacy policy was last updated on October 13, 2022.",
		jurisdiction:
			router.locale === "ar-AE"
				? "٧. الولاية القضائية"
				: router.locale === "kn-IN"
					? "7. ವ್ಯಾವಸಾಯಿಕ ನ್ಯಾಯಾಧಿಕರಣ"
					: "7. Jurisdiction",
		jurisdictioncontent:
			router.locale === "ar-AE"
				? "إذا اخترت زيارة الموقع الإلكتروني، فإن زيارتك وأي نزاع يتعلق بالخصوصية يخضع لهذه السياسة ولشروط استخدام الموقع. بالإضافة إلى ما سبق، فإن أي نزاعات تنشأ بموجب هذه السياسة ستكون خاضعة لقوانين الهند."
				: router.locale === "kn-IN"
					? "ನೀವು ವೆಬ್‌ಸೈಟ್‌ಗೆ ಭೇಟಿ ನೀಡಲು ಆಯ್ಕೆ ಮಾಡುವಾಗ, ನಿಮ್ಮ ಭೇಟಿ ಮತ್ತು ಗೌಪ್ಯತೆ ಮೇಲೆ ಏನಾದರೂ ವಿವಾದ ಈ ನೀತಿ ಮತ್ತು ವೆಬ್‌ಸೈಟ್‌ನ ಬಳಕೆಯ ನಿಯಮಗಳ ಕೆಳಗೆ ಇರುವದು. ಮೇಲಿನಿಂದ ಹೆಚ್ಚಿನವರೆಗೆ, ಈ ನೀತಿಯ ಅಡಿಯಲ್ಲಿ ವಿವಾದಗಳು ಭಾರತದ ಕಾನೂನುಗಳಿಗೆ ಅಧೀನವಾಗಿರುತ್ತವೆ."
					: "If you choose to visit the website, your visit and any dispute over privacy are subject to this policy and the website's terms of use. In addition to the foregoing, any disputes arising under this policy shall be governed by the laws of India.",
	};
	return (
		<React.Fragment>
			<SectionContainer
				sx={{
					direction: router.locale === "ar-AE" ? "rtl" : "ltr",
				}}
			>
				<List>
					<Heading>{localLang.definitions}</Heading>
					<ul
						style={{
							listStyleType: "none",
						}}
					>
						<li
							style={{
								padding: "0.5rem 0rem 0.5rem 0rem",
							}}
						>
							{localLang.definitionsContentOne}
						</li>
						<li>
							{localLang.definitionsContentTwo}
							<Link
								href="https://beegru.com"
								rel="noopener"
								target="_self"
								referrerPolicy="no-referrer"
							>
								beegru.com
							</Link>
							.
						</li>
					</ul>
				</List>
				<List>
					<Heading>{localLang.personalinfo}</Heading>
					<ul
						style={{
							listStyleType: "none",
						}}
					>
						<li
							style={{
								padding: "0.5rem 0rem 0.5rem 0rem",
							}}
						>
							{localLang.personalinfocontentone}
						</li>
						<li>
							{localLang.personalinfocontenttwo}
							<ol type="a">
								<li>{localLang.personalinfocontenttwoListOne}</li>
								<li>{localLang.personalinfocontenttwoListTwo}</li>
								<li>{localLang.personalinfocontenttwoListThree}</li>
								<li>{localLang.personalinfocontenttwoListFour}</li>
								<li>{localLang.personalinfocontenttwoListFive}</li>
							</ol>
						</li>
						<li>{localLang.personalinfocontentthree}</li>
						<li>{localLang.personalinfocontentfour}</li>
					</ul>
				</List>
				<List>
					<Heading>{localLang.purpose}</Heading>
					<li>
						{localLang.purposecontentone}
						<ol type="a">
							<li>{localLang.purposecontentoneListOne}</li>
							<li>{localLang.purposecontentoneListTwo}</li>
							<li>{localLang.purposecontentoneListThree}</li>
							<li>{localLang.purposecontentoneListFour}</li>
							<li>{localLang.purposecontentoneListFive}</li>
							<li>{localLang.purposecontentoneListSix}</li>
							<li>{localLang.purposecontentoneListSeven}</li>
							<li>{localLang.purposecontentoneListEight}</li>
							<li>{localLang.purposecontentoneListNine}</li>
							<li>{localLang.purposecontentoneListTen}</li>
						</ol>
					</li>
					<li>{localLang.purposecontenttwo}</li>
					<li>{localLang.purposecontentthree}</li>
					<li>{localLang.purposecontentfour}</li>
				</List>
				<List>
					<Heading>{localLang.disclosure}</Heading>
					<li>{localLang.disclosurecontentone}</li>
					<li>{localLang.disclosurecontenttwo}</li>
					<li>
						{localLang.disclosurecontentthree}
						<ol type="a">
							<li>{localLang.disclosurecontentthreeListOne}</li>
							<li>{localLang.disclosurecontentthreeListTwo}</li>
							<li>{localLang.disclosurecontentthreeListThree}</li>
							<li>{localLang.disclosurecontentthreeListFour}</li>
							<li>{localLang.disclosurecontentthreeListFive}</li>
						</ol>
					</li>
					<li>{localLang.disclosurecontentfour}</li>
				</List>
				<List>
					<Heading>{localLang.contactcompany}</Heading>
					<li>
						{localLang.contactcompanycontent}
						<ul
							style={{
								listStyleType: "none",
							}}
						>
							<li>{localLang.contactcompanycontenTo}</li>
							<li>{localLang.contactcompanycontentAttention}</li>
							<li>{localLang.contactcompanycontentAddress}</li>
							<li>{localLang.contactcompanycontentTelephone}</li>
							<li>{localLang.contactcompanycontentEmail}</li>
						</ul>
					</li>
					<li>{localLang.contactcompanycontenttwo}</li>
				</List>
				<List>
					<Heading>{localLang.updates}</Heading>
					<li>{localLang.updatecontentone}</li>
					<li>{localLang.updatecontenttwo}</li>
				</List>
				<List>
					<Heading>{localLang.jurisdiction}</Heading>
					<li
						style={{
							padding: "0rem 0rem 1rem 0rem",
						}}
					>
						{localLang.jurisdictioncontent}
					</li>
				</List>
			</SectionContainer>
		</React.Fragment>
	);
};
export default SectionTwo;
